import React from "react";

import { useTheme } from "styled-components";

import Icon, { getIconType } from "../../../../../components/ui/icon/Icon";
import Time from "../../timer/Time";
import EditableText from "../../inline-edit/EditableText";
import EditableLine from "../../inline-edit/EditableLine";
import {
  Button,
  Emoji,
  IconEmojiContainer,
  IconText,
  Text,
  TimerButton,
  Title,
  TitleText,
  Wrapper,
} from "./style";
import { urlValidator } from "../../../../../helpers/validators";

function FixedColor({ data, isEditable, viewMode = "view" }) {
  const {
    title,
    text,
    colorFields,
    timerLayout,
    time,
    url,
    newTab,
    icon,
    borderRadius,
    linkText,
  } = data;

  const iconType = getIconType(icon);

  const theme = useTheme();

  const checkLayout = (prop) =>
    !!timerLayout.find((item) => item.value === prop);

  return (
    <Wrapper
      borderRadius={borderRadius}
      onClick={(e) => {
        if (checkLayout("label")) return;
        if (
          viewMode === "view" &&
          urlValidator({ url: url?.link, protocols: ["https:"] })
        )
          window.open(url?.link, newTab ? "_blank" : "_top");
      }}
    >
      <IconText>
        {checkLayout("icon") && (
          <IconEmojiContainer>
            {iconType === "emoji" && <Emoji>{icon.native}</Emoji>}

            {iconType === "icon" && <Icon icon={icon} size="35px" />}

            {iconType === "app" && <img src={icon} alt="img" height="35px" />}
          </IconEmojiContainer>
        )}

        <TitleText>
          <Title hasText={checkLayout("text")}>
            <EditableText
              value={title}
              propKey="title"
              isEditable={isEditable}
              customCalculatorStyles={{ minHeight: "1em" }}
            />
          </Title>
          {checkLayout("text") && (
            <Text>
              <EditableText
                value={text}
                propKey="text"
                isEditable={isEditable}
              />
            </Text>
          )}
        </TitleText>
      </IconText>

      <TimerButton>
        <Time time={time} color={theme.text.input} />
        {checkLayout("label") && (
          <Button
            bgClr={colorFields.Timer[theme.name]}
            matchColor={true}
            onClick={() => {
              if (
                viewMode === "view" &&
                urlValidator({ url: url?.link, protocols: ["https:"] })
              )
                window.open(url?.link, newTab ? "_blank" : "_top");
            }}
          >
            <EditableLine
              value={linkText}
              propKey="linkText"
              isEditable={isEditable}
            />
          </Button>
        )}
      </TimerButton>
    </Wrapper>
  );
}

export default FixedColor;
